export { default } from "./RegistroIngredientes";
